import { render, staticRenderFns } from "./ClientTranslations.vue?vue&type=template&id=4777508b"
import script from "./ClientTranslations.vue?vue&type=script&lang=js"
export * from "./ClientTranslations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports